/**
 * Custom checkbox to allow styling plus label and generic update function
 */
import { ChangeEventHandler, ReactNode } from "react";
import "./Checkbox.scss";
type Props = {
  labelText: ReactNode;
  onChange: ChangeEventHandler<HTMLInputElement> | undefined;
  disabled: boolean;
  id: string;
  loading?: boolean;
  checked: boolean;
};

export const CheckboxWithLabel = (props: Props) => (
  <div className={`checkbox-container ${props.loading ? "disabled" : ""}`}>
    <div className="checkbox">
      <input
        type="checkbox"
        onChange={props.onChange}
        id={props.id}
        checked={props.checked}
      />
      <label htmlFor={props.id} />
    </div>
    <span className="checkbox__text">{props.labelText}</span>
  </div>
);
